import type { DetailsCardProps } from 'components';
import { DISABLED_STATUSES_EMPLOYEE, DISABLED_STATUSES_IPA } from 'consts/statuses';
import { AppContext } from 'providers/AppContext';
import { useContext, useState } from 'react';

export function useDetailsCard({ info, onClick }: DetailsCardProps) {
	const ctx = useContext(AppContext);
	const { config, fetchRelations, flowType, http, t } = ctx;
	const { API, API_DIGITAL_SIGNATURE_URL, IS_EMPLOYEE_WEB } = config;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { kennitala, processInfo } = info;
	const { agreementProcessId = '', processStatus = 0 } = processInfo || {};
	const statuses = IS_EMPLOYEE_WEB ? DISABLED_STATUSES_EMPLOYEE : DISABLED_STATUSES_IPA;
	const btnLabel = t(statuses[processStatus as keyof typeof statuses], 'userboard');
	const onClickCancel = () => setIsModalOpen(true);
	const onClose = () => setIsModalOpen(false);

	const select = () => {
		!info.disabledCard && onClick(kennitala);
	};

	const redirect = () => {
		if (!info.disabledButton) {
			globalThis.location.href = API_DIGITAL_SIGNATURE_URL;
		}
	};

	const onCancelProcess = async () => {
		onClose();
		await http.delete(`${API.deleteProcess}/${agreementProcessId}`);
		await fetchRelations();
	};

	return {
		...ctx,
		btnLabel,
		IS_EMPLOYEE_WEB,
		processStatus,
		isModalOpen,
		onClose,
		flowType,
		onCancelProcess,
		onClickCancel,
		redirect,
		select
	};
}
